import { CustomerSitesResponse } from '@/api/customers/types';
import { SelectedLocation } from '@/features/dashboard/widgets/completed-cycles/filters/LocationFiltersDialog';

export function getLocationFilterName(
	customerId?: string,
	selectedSiteId?: string,
	locationsFilter?: SelectedLocation[],
	customerSites?: CustomerSitesResponse[]
): string {
	const ALL_CUSTOMERS_ID = 'all-customers';
	const ALL_SITES_ID = 'all-sites';

	if (customerId === ALL_CUSTOMERS_ID) {
		return 'All Clients';
	}

	// 2) Lowest selected location (deepest filled)
	if (Array.isArray(locationsFilter) && locationsFilter.length) {
		const firstUnfilledIndex = locationsFilter.findIndex((s) => !s?.location);
		const noneSelected = firstUnfilledIndex === 0;
		if (!noneSelected) {
			const lastFilledIndex =
				firstUnfilledIndex === -1 ? locationsFilter.length - 1 : firstUnfilledIndex - 1;
			const last = locationsFilter[lastFilledIndex];
			const locName = last?.location?.name;
			if (locName) {
				const levelName = last?.level?.name;
				// If location name is short (<=5 chars), prefix with level name (if available)
				if (locName.length <= 5 && levelName) {
					return `${levelName} ${locName}`;
				}

				return locName;
			}
		}
	}

	// 3) No location selected -> prefer site name (if a site is selected), then customer name
	if (selectedSiteId && selectedSiteId !== ALL_SITES_ID && customerSites?.length) {
		const customerFromSite = customerSites.find(
			(c) => c?.sites?.some((s) => s?.id === selectedSiteId)
		);
		const site = customerFromSite?.sites?.find((s) => s?.id === selectedSiteId);
		if (site?.name) {
			return site.name;
		}
	}

	const customerById = customerSites?.find((c) => c?.id === customerId);
	if (customerById?.name) {
		return customerById.name;
	}
	return 'All Clients';
}
